/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const TriangleAlert16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <g fill={vars.bdlGray} fillRule="evenodd">
            <path d="M6.284 1.97a2 2 0 013.323-.164l.11.164 5.985 10.003a2 2 0 01-1.536 3.019l-.18.008H2.014a2 2 0 01-1.802-2.868l.086-.159L6.284 1.97zm2.23.17a1 1 0 00-1.306.247l-.066.097-5.986 10.002a1 1 0 00.741 1.507l.117.007h11.972a1 1 0 00.912-1.41l-.054-.104L8.858 2.484a1 1 0 00-.344-.345zM8 4.5a.75.75 0 01.743.648l.007.102v4.5a.75.75 0 01-1.493.102L7.25 9.75v-4.5A.75.75 0 018 4.5z" />
            <circle cx={8} cy={12.25} r={1} />
        </g>
    </AccessibleSVG>
);

export default TriangleAlert16;
